import { render, staticRenderFns } from "./ModelViewerTab.vue?vue&type=template&id=41530537&scoped=true"
import script from "./ModelViewerTab.vue?vue&type=script&lang=ts"
export * from "./ModelViewerTab.vue?vue&type=script&lang=ts"
import style0 from "./ModelViewerTab.vue?vue&type=style&index=0&id=41530537&lang=sass&scoped=true"
import style1 from "./ModelViewerTab.vue?vue&type=style&index=1&id=41530537&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41530537",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41530537')) {
      api.createRecord('41530537', component.options)
    } else {
      api.reload('41530537', component.options)
    }
    module.hot.accept("./ModelViewerTab.vue?vue&type=template&id=41530537&scoped=true", function () {
      api.rerender('41530537', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/ModelViewerTab.vue"
export default component.exports